import { Box } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import MachineConfiguration from '../MachineConfiguration/MachineConfiguration'
import { DeviceThing } from '../../types/DeviceThing.types'
import { useParams } from 'react-router-dom'
import AppContext from '../../context/AppContext'
import { fetchIoTDevice } from '../../services/machines/machinesApi'
import SingleMachineContext from '../../context/SingleMachineContext'

const MachineView = () => {
    const { thingName } = useParams<{ thingName: string }>()
    const { awsInstanceIot, awsInstanceIotData } = React.useContext(AppContext)

    const [machine, setMachine] = useState<DeviceThing | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            if (!awsInstanceIot || !awsInstanceIotData || !thingName) return
            setIsLoading(true)
            setError(null)
            try {
                const device = await fetchIoTDevice(thingName, awsInstanceIot, awsInstanceIotData)
                if (!cancelled) setMachine(device)
            } catch (e: any) {
                if (!cancelled) setError(e?.message ?? 'Failed to load device')
            } finally {
                if (!cancelled) setIsLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [awsInstanceIot, awsInstanceIotData, thingName])

    if (isLoading) return <div>Loading...</div>
    if (error) return <div>{error}</div>
    if (!machine) return <div>Device not found</div>

    return (
        <Box className="machineView">
            <SingleMachineContext.Provider value={{ machine, isLoading }}>
                <Fragment>
                    <MachineConfiguration />
                </Fragment>
            </SingleMachineContext.Provider>
        </Box>
    )
}

export default MachineView
